import { render, staticRenderFns } from "./RaceRunners.vue?vue&type=template&id=dae2c646&scoped=true&"
import script from "./RaceRunners.vue?vue&type=script&lang=js&"
export * from "./RaceRunners.vue?vue&type=script&lang=js&"
import style0 from "./RaceRunners.vue?vue&type=style&index=0&id=dae2c646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae2c646",
  null
  
)

export default component.exports